<template>
    <div>
        <Button severity="primary" :size="size" :label="t('billing.upgradePlan')" icon="pi pi-arrow-circle-up"
            :disabled="buttonDisabled" @click="openDialog" />
        <PlanSwitchDialog v-model:visible="visible" />
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import Button from 'primevue/button'
import { useI18n } from 'vue-i18n'
import { useTenantsStore } from '@/stores/tenants'
import { TenantPlan, isCreditPlan } from '@/models/Tenant'
import PlanSwitchDialog from '@/components/settings/billing/PlanSwitchDialog.vue'
import { useSelfServeGate } from '@/composables/useSelfServeGate'

withDefaults(defineProps<{
    size?: 'small' | 'large' | undefined
}>(), {
    size: undefined
})

const { t } = useI18n()
const tenantsStore = useTenantsStore()
const { shouldContactSalesForPlanSwitch, openContactSales } = useSelfServeGate()

const visible = ref(false)

const currentPlan = computed(() => tenantsStore.currentTenant?.plan || null)

const buttonDisabled = computed(() => {
    const plan = currentPlan.value
    if (isCreditPlan(plan)) return false
    return plan === TenantPlan.EVALUATOR
})

function openDialog() {
    // Existing tenants never self-serve a plan change while gated (MYAC-837) —
    // redirect to Contact sales before the price picker can open.
    if (shouldContactSalesForPlanSwitch()) {
        openContactSales('upgrade')
        return
    }
    visible.value = true
}
</script>

<style scoped></style>